<template>
    <div class="step-card-container">
        <div class="step-card-header">
            <div class="title-container">
                <p>
                    {{ title }}
                </p>
            </div>
            <button class="edit-btn" @click="edit" :title="$t('app.button.edit')">
                <img class="edit-icon" :src="getEditIcon" alt="" aria-hidden="true" />
            </button>
        </div>
        <div class="content-card-container">
            <slot />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        title: { type: String, required: true },
    },
    methods: {
        edit() {
            this.$emit('edit');
        },
    },
    computed: {
        getEditIcon() {
            return require('@/assets/img/edit.svg');
        },
    },
});
</script>

<style scoped>
.edit-btn {
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
}
.edit-icon {
    height: 24px;
    width: 24px;
    margin: 0;
}
.step-card-container {
    border: 1px solid var(--medium-light-grey);
    border-radius: 4px;
}
.step-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: var(--medium-grey);
    padding: 20px 24px;
    border-bottom: none;
}
.title-container {
    font-size: var(--font-size-low-medium);
    color: var(--color-principal);
    text-transform: uppercase;
}
.title-container span {
    font-family: 'Raleway Semi Bold', sans-serif;
    font-variant-numeric: lining-nums;
}
.content-card-container {
    padding: 20px 24px;
}
</style>
